import { createContext, ReactNode, useContext } from "react";

export type TModalContext = {
	open: (callback: () => ReactNode) => string;
	close: (id: string) => void;
};

const initialState: TModalContext = {
	open() {
		return "";
	},
	close() {},
};

export const ModalContext = createContext<TModalContext>(initialState);

export const useModal = () => useContext(ModalContext);
